export const PERMS = {
    READ: 'warehousing_issues.read',
    UPDATE: 'warehousing_issues.update',
    DELETE: 'warehousing_issues.delete',
    CREATE: 'warehousing_issues.create',
    EXPORT: 'warehousing_issues.export',
}